import type { Lane, RouteStep } from '../core/types';
import { laneValid } from './lanes';
import { stepRefs } from './roads';

export function straightLaneContinuation(lanes: Lane[] | null | undefined): boolean {
  const valid = lanes?.filter(laneValid) ?? [];
  return valid.length > 0 && valid.every(lane =>
    lane.valid_indication ? lane.valid_indication === 'straight'
      : lane.indications?.length === 1 && lane.indications[0] === 'straight');
}

export function sameRoadContinuation(from: RouteStep | null, to: RouteStep | null): boolean {
  if (!from || !to) return false;
  const type = to.maneuver.type;
  if (type === 'off ramp' || type === 'on ramp' || type === 'turn' || type === 'merge') return false;
  const mod = to.maneuver.modifier ?? '';
  if (!['straight', 'slight left', 'slight right'].includes(mod)) return false;
  const a = stepRefs(from), b = stepRefs(to);
  const same = a.length && b.length ? a.some(ref => b.includes(ref))
    : !!from.name?.trim() && from.name.trim() === to.name?.trim();
  if (!same) return false;
  const before = to.maneuver.bearing_before, after = to.maneuver.bearing_after;
  return mod === 'straight' || (typeof before === 'number' && typeof after === 'number'
    && Math.abs(((after - before + 540) % 360) - 180) <= 30);
}
